import { FadeIn } from "@/components/FadeIn";
import React from "react";
import background from "/HeroSignUp.svg";
import rebootLogo from "/reboot-logo.svg";

// This index.css is needed to alter the Ory elements that we are using.
import "./index.css";

export const AuthLayout = ({
  children,
  callToAction,
}: {
  children: React.ReactNode;
  callToAction: string;
}) => {
  return (
    <FadeIn durationMilliseconds={800}>
      <div className="lg:grid lg:grid-cols-2 lg:max-w-none min-h-screen">
        <div className="flex items-center justify-center py-8 lg:py-12">
          <div className="flex flex-col w-full max-w-[434px] px-4 lg:px-0">
            <img src={rebootLogo} className="px-12 mr-20 w-64 mb-6" />
            <h1 className="px-12 font-bold">{callToAction} today</h1>
            <div className="px-12">
              Start building your full stack app today.
            </div>
            <div className="px-12">Run it durably in the cloud tomorrow.</div>
            <div>{children}</div>
          </div>
        </div>
        <div className="hidden lg:block lg:sticky lg:top-0 lg:h-screen">
          <div className="flex items-center justify-center h-full">
            <img className="max-h-screen p-4" src={background} />
          </div>
        </div>
      </div>
    </FadeIn>
  );
};
